import React, { useState, useRef } from "react";
import {
  Grid,
  TextField,
  Button,
  Autocomplete,
  DataGrid,
  CircularProgress,
  ButtonGroup,
  Paper,
  ClickAwayListener,
  MenuList,
  MenuItem,
  Grow,
  Popper,
} from "../../../../components";
import { ProdutosService, notification } from "../../../../services";
import { responseErros, formatPrice } from "../../../../utils";

const ProdutosSimilaresDialog = ({
  produtosSimilares,
  setProdutosSimilares,
  id,
}) => {
  const inputRef = useRef();
  const produtoService = new ProdutosService();
  const [loadingAutoComplete, setLoadingAutoComplete] = useState(false);
  const [listaProdutos, setListaProdutos] = useState([]);
  const [produtoSelecionado, setProdutoSelecionado] = useState(null);
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const produtosColunas = [
    {
      field: "codigo",
      headerName: "Cod.",
      flex: 280,
    },
    {
      field: "descricao",
      headerName: "Produtos",
      flex: 700,
    },
    {
      field: "estoque",
      headerName: "Estoque",
      flex: 350,
    },
    {
      field: "precoVenda",
      headerName: "Preço Venda",
      flex: 500,
      valueGetter: (params) => formatPrice(params.value),
    },
  ];

  const buscarProdutos = async (filtros) => {
    const filtro = {
      ...filtros,
    };
    const isClone = "id" in filtro && Array.isArray(filtro.id);
    if (!isClone) filtro.produtoGrade = true;
    const result = await produtoService.getAll(filtro);
    setLoadingAutoComplete(false);
    if (!result.isAxiosError) {
      if (isClone) return result.data.rows;
      setListaProdutos(result.data.rows);
    } else {
      responseErros(result);
    }
  };

  const handleChangeProdutoSelecionado = (e, value) => {
    setProdutoSelecionado(value);
    document.getElementById("buttonAdicionar").focus();
  };

  const handleToggle = (event) => {
    setOpen((prevOpen) => !prevOpen);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    if (anchorEl.current && anchorEl.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const onSearchChangeProdutos = (event) => {
    if (event.key === "Enter" && inputRef.current === document.activeElement) {
      const eventValue = event.target?.value;
      if (eventValue?.length >= 2) {
        let filtros = {
          descricao: eventValue,
          restritiva: true,
        };
        if (id) {
          filtros = { ...filtros, id };
        }
        setLoadingAutoComplete(true);
        buscarProdutos(filtros);
      }
    }
  };

  const handleAdicionarProduto = () => {
    if (!produtoSelecionado) {
      return notification.alertaGenericos(
        "Selecione um produto para adicionar"
      );
    }
    const produtoInserido = produtosSimilares.find(
      (item) => item.id == produtoSelecionado.id
    );
    if (produtoInserido) {
      notification.alertaGenericos("Produto já inserido");
    } else {
      setProdutosSimilares((prevState) => [...prevState, produtoSelecionado]);
    }
    setProdutoSelecionado(null);
    setListaProdutos([]);
    document.getElementById("produtoId").focus();
  };

  const handleRemoverProduto = async (id) => {
    const data = produtosSimilares.filter((item) => item.id !== id);
    const produtoRemovido = produtosSimilares.find(
      (item) => item.id === id
    ).descricao;
    const retornoAlerta = await notification.confirmacao(
      "Excluir!",
      `Tem certeza que deseja excluir ${
        produtoRemovido
          ? produtoRemovido
          : "este produto da lista de produtos similares"
      }?`
    );
    if (retornoAlerta.isConfirmed) {
      setProdutosSimilares(data);
    }
  };

  async function clonarSimilares() {
    const similaresIds = produtoSelecionado?.similares.filter(
      (similar) => similar && similar != id
    );
    if (!similaresIds.length) {
      return notification.alertaGenericos("Este produto não contém similares");
    }
    const produtosSimilares = await buscarProdutos({
      id: similaresIds,
    });
    const produtosMontados = produtosSimilares.map((produto) => ({
      ...produto,
      ...produto.informacao,
      ...produto.estoqueProduto,
    }));
    setProdutosSimilares((prevState) => [...prevState, ...produtosMontados]);
    setProdutoSelecionado(null);
    setListaProdutos([]);
    setOpen(false);
  }

  return (
    <>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={6}>
          <Autocomplete
            id="produtoId"
            name="produtoId"
            options={listaProdutos}
            autoHighlight
            getOptionLabel={(option) => option?.descricao ?? ""}
            filterSelectedOptions
            onChange={handleChangeProdutoSelecionado}
            value={produtoSelecionado}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Buscar produto"
                onKeyDown={onSearchChangeProdutos}
                inputRef={inputRef}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      <React.Fragment>
                        {loadingAutoComplete ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    </>
                  ),
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={6}>
          <ButtonGroup variant="contained" color="info">
            <Button
              id="buttonAdicionar"
              onClick={handleAdicionarProduto}
              size="large"
            >
              <i
                className="ph-fill ph-plus-circle"
                style={{ color: "#fff", fontSize: 22, marginRight: 10 }}
              ></i>
              Adicionar
            </Button>
            <Button
              size="small"
              aria-controls={open ? "split-button-menu" : undefined}
              aria-expanded={open ? "true" : undefined}
              aria-haspopup="menu"
              onClick={handleToggle}
            >
              <i
                className="ph-fill ph-caret-down"
                style={{ color: "#fff", fontSize: 15 }}
              ></i>
            </Button>
          </ButtonGroup>
        </Grid>
        <Popper
          className="menu-selecao"
          open={open}
          anchorEl={anchorEl}
          placement="bottom-end"
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "center botton"
                    ? "center top"
                    : "center bottom",
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList autoFocusItem>
                    <MenuItem
                      key={"Clonar Similares"}
                      onClick={() => clonarSimilares()}
                    >
                      {"Clonar Similares"}
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </Grid>
      <Grid container spacing={4} sx={{ marginTop: "1px" }}>
        <Grid item xs={12}>
          <DataGrid
            rows={produtosSimilares}
            columns={produtosColunas}
            rowCount={produtosSimilares.length}
            deleteShow
            onClickDelete={handleRemoverProduto}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default ProdutosSimilaresDialog;
